export default __webpack_public_path__ + "static/media/house.15f0bb7b.webp";